import React                         from 'react';
import {
    useLocation,
    Location,
    NavigateFunction,
    useNavigate
}                                    from 'react-router-dom';

import MenuItem                      from 'components/MenuItem';
import InfiniteTable                 from 'components/InfiniteTable';
import tectransit                    from 'utils/TecTransit';
import dayjs                         from 'shared/utils/day-timezone';
import * as FeedbackMessageType      from 'shared/types/PublicFeedback';

export interface Props {
    location? : Location;
    navigate: NavigateFunction
}

class FeedbackTable extends InfiniteTable<FeedbackMessageType.Message> {

    static MAX_LENGTH = 20;

     // @ts-expect-error
     public  props       : Props;

    fetchRows( orderby:string, limit:number, skip:number ) {
        return this.getTablePromise('/api/dispatcher/feedback','GET',undefined,{orderby,limit,skip});
    }
    renderThead() {
        return (
            <tr>
                <th onClick={()=>this.sort('submitterEmail')}>{this.getSortingIcon('submitterEmail')}Email</th>
                <th onClick={()=>this.sort('subject')}>{this.getSortingIcon('subject')}Subject</th>
                <th onClick={()=>this.sort('message')}>{this.getSortingIcon('message')}Message</th>
                <th onClick={()=>this.sort('dateCreated')}>{this.getSortingIcon('dateCreated')}Created</th>
                <th onClick={()=>this.sort('dateResponded')}>{this.getSortingIcon('dateResponded')}Replied</th>
                <th onClick={()=>this.sort('submitterIP')}>{this.getSortingIcon('submitterIP')}Submitter IP</th>
                <th></th>
            </tr>
        );
    }
    renderRow(message: FeedbackMessageType.Message) {
        return (
            <tr key={message._id} style={{ verticalAlign: 'top' }}>
                <td style={{ verticalAlign: 'top' }}>
                    {message.submitterEmail.length > FeedbackTable.MAX_LENGTH ? message.submitterEmail.slice(0, FeedbackTable.MAX_LENGTH) + '...' : message.submitterEmail}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {message.subject.length > FeedbackTable.MAX_LENGTH ? message.subject.slice(0, FeedbackTable.MAX_LENGTH) + '...' : message.subject}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {message.message.length > FeedbackTable.MAX_LENGTH ? message.message.slice(0, FeedbackTable.MAX_LENGTH) + '...' : message.message}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {dayjs(message.dateCreated).tz(tectransit.agency.time_zone).format(tectransit.timeFormat)}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {message.dateResponded ? dayjs(message.dateResponded).tz(tectransit.agency.time_zone).format(tectransit.timeFormat) : null}
                </td>
                <td style={{ verticalAlign: 'top' }}>
                    {message.submitterIP}
                </td>
                <td>
                    <button
                        className={`btn-theme btn-small ${message.dateResponded ? 'disabled-button' : ''}`}
                        style={message.dateResponded ? { opacity: 0.5, cursor: 'not-allowed',  } : undefined}
                        onClick={(e) => {
                            e.preventDefault();
                            if (message.dateResponded) return;
                            this.props.navigate(`/Dispatcher/Feedback/Reply`, {
                                state: { selectedMessage: message }
                            });
                        }}
                        disabled={message.dateResponded ? true: false}
                        title={!message.dateResponded ? 'Not yet replied' : 'Reply to this message'}
                        >
                        Reply
                    </button>
                </td>
            </tr>
        );
    }
}

export default function Feedback() {
    const location = useLocation();
    const navigate = useNavigate();
    return (
        <MenuItem title="FeedbackTable">
            <FeedbackTable
                location={location}
                navigate={navigate}
            />
        </MenuItem>
    );
}